import { EventEmitter } from '../depsNode.native';
import { EMIT_READY } from '../enum/index';
/**
 * The `Visitor` class represents a unique user within your application. It aids in
 * managing the visitor's data and fetching the corresponding flags for the visitor
 * from the [Flagship platform](https://app.flagship.io/login) .
 */
export class Visitor extends EventEmitter {
    visitorDelegate;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _onReady;
    constructor(visitorDelegate) {
        super();
        this.visitorDelegate = visitorDelegate;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._onReady = (err) => {
            this.emit(EMIT_READY, err);
        };
        this.visitorDelegate.on(EMIT_READY, this._onReady);
        const instance = this;
        instance.sendEaiVisitorEvent = (event) => {
            this.visitorDelegate.sendEaiVisitorEvent(event);
        };
        instance.sendEaiPageView = (pageView) => {
            this.visitorDelegate.sendEaiPageView(pageView);
        };
        instance.onEAICollectStatusChange = (callback) => {
            this.visitorDelegate.onEAICollectStatusChange(callback);
        };
    }
    /**
     * @inheritdoc
     */
    get visitorId() {
        return this.visitorDelegate.visitorId;
    }
    /**
     * @inheritdoc
     */
    set visitorId(v) {
        this.visitorDelegate.visitorId = v;
    }
    /**
     * @inheritdoc
     */
    get anonymousId() {
        return this.visitorDelegate.anonymousId;
    }
    /**
     * @inheritdoc
     */
    get config() {
        return this.visitorDelegate.config;
    }
    /**
     * @inheritdoc
     */
    get context() {
        return this.visitorDelegate.context;
    }
    /**
     * @inheritdoc
     */
    get flagsStatus() {
        return this.visitorDelegate.flagsStatus;
    }
    /**
     * @inheritdoc
     */
    get hasConsented() {
        return this.visitorDelegate.hasConsented;
    }
    /**
     * @inheritdoc
     */
    setConsent(hasConsented) {
        this.visitorDelegate.setConsent(hasConsented);
    }
    updateContext(context, value) {
        this.visitorDelegate.updateContext(context, value);
    }
    /**
     * @inheritdoc
     */
    clearContext() {
        this.visitorDelegate.clearContext();
    }
    /**
     * @inheritdoc
     */
    getFlag(key) {
        return this.visitorDelegate.getFlag(key);
    }
    /**
     * @inheritdoc
     */
    getFlags() {
        return this.visitorDelegate.getFlags();
    }
    /**
     * @inheritdoc
     */
    fetchFlags() {
        return this.visitorDelegate.fetchFlags();
    }
    sendHit(hit) {
        return this.visitorDelegate.sendHit(hit);
    }
    sendHits(hits) {
        return this.visitorDelegate.sendHits(hits);
    }
    /**
     * @inheritdoc
     */
    authenticate(visitorId) {
        this.visitorDelegate.authenticate(visitorId);
    }
    /**
     * @inheritdoc
     */
    unauthenticate() {
        this.visitorDelegate.unauthenticate();
    }
    /**
     * @inheritdoc
     */
    collectEAIEventsAsync(...args) {
        let currentPage;
        if (args.length > 0) {
            currentPage = args[0];
        }
        return this.visitorDelegate.collectEAIEventsAsync(currentPage);
    }
    /**
     * @inheritdoc
     */
    cleanup() {
        this.visitorDelegate.cleanup();
        this.visitorDelegate.off(EMIT_READY, this._onReady);
    }
}
